import { scrollPageToReviews } from './scroll-page-to-reviews';
import { WindowLocation } from '../../../_common/client/window-location';

export function scrollToReviewsIfStarFilterIsSet(reviewListElement: HTMLElement) {
    if (isStarFilterSetInUrl()) {
        scrollPageToReviews(reviewListElement);
    }
}

function isStarFilterSetInUrl() {
    const urlSearchParams = new URLSearchParams(WindowLocation.getSearch());
    return !!urlSearchParams.get('filter');
}
